import './index.scss'

import { useState } from 'react'

import { useAuth } from '@auth/AuthProvider'
import Modal from '@components/Modal'
import StaffController from '@data/controller/StaffController'
import { ChurchStaff } from '@data/interfaces/church.interfaces'

import closeIcon from 'url:@icon/close.svg';

// Styled after RemoveVolunteerModal.
export default function DeleteStaffMemberModal(props: {
  isOpen: boolean,
  staff?: ChurchStaff | null,
  close: () => void,
  onDeleted: () => void
}) {
  const auth = useAuth();
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteStaffMember = async () => {
    if (!auth.churchId || !props.staff) {
      setError('Missing church context. Please refresh and try again.');
      return;
    }

    setIsDeleting(true);
    setError(null);

    try {
      const response = await StaffController.deleteStaffMember(auth.churchId, props.staff.id, auth);

      if (response.error) {
        setError(response.error);
        return;
      }

      props.onDeleted();
    } finally {
      setIsDeleting(false);
    }
  };

  const name = props.staff?.name ?? 'this staff member';

  return <Modal
    id='delete-staff-member-modal'
    isOpen={props.isOpen}
    footerButtons={[]}>
    <div className='delete-staff-member-modal-content'>
      <div className='header'>
        <button
          type='button'
          className='header-control close'
          disabled={isDeleting}
          onClick={props.close}>
          <img src={closeIcon} alt='Close icon' />
        </button>

        <h3 className='title'>Delete Staff Member</h3>

        <span className='header-control-spacer' />
      </div>

      <div className='body'>
        {error ? <p className='save-error'>{error}</p> : null}

        <p className='delete-copy'>
          <strong>Delete {name}'s Church Hub account?</strong>
        </p>

        <p className='caption'>They'll no longer be able to sign in to Church Hub. You can invite them again at any time.</p>

        <button
          type='button'
          className='delete-button'
          disabled={isDeleting}
          onClick={() => {
            void deleteStaffMember();
          }}>
          {isDeleting ? 'Deleting...' : 'Delete Staff Member'}
        </button>
      </div>
    </div>
  </Modal>
}
